import React from 'react';
import Pages from './Pages.js';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';


class Sponsor extends Pages {

    componentDidMount() {
        window.scrollTo(0, 0)
        // setTimeout(function () {
        //     this.setState({ isLoading: false });
        // }.bind(this), 5000);
    }

    leftmenu = () => {
        return (

            <div className='leftmenu'>
            </div>
        )
    }
    righttext = () => {
        return (
            <div className='righttext' style={{width: '80%'}}>
                <h3>HKU iGEM 2022 would like to express our sincerest gratitude to our generous sponsors. This project would not have happened without the support from our sponsors.</h3>
                
                <div style={{ display: 'flex' }}>
                    <img src={'https://static.igem.wiki/teams/4241/wiki/sponsors/new5.png'} alt='' style={{ width: '40%' }} />
                    <div>
                        <br />
                        <h2>HKU Science</h2>
                        <br />
                        Established in 1939, HKU Faculty of Science strives for excellence in both research and teaching, takes the lead to be the pioneer of knowledge exchange. Building on our achievements over the past eight decades, the Faculty has made huge strides and will continue to do so in striving for excellence, creating a global presence and regional significance, and maintaining its role in delivering impacts to the community at large.
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <img src={'https://static.igem.wiki/teams/4241/wiki/sponsors/new4.png'} alt='' style={{ width: '40%' }} />
                    <div>
                        <br />
                        <h2>HKU Biomedical Science</h2>
                        <br />
                        The School of Biomedical Sciences is committed to the provision of high-quality biomedical science education in the professional training of the new generation of healthcare workforce in the 21st century. Our specially-designed courses enable fledgling health professionals to develop competence, based upon sound scientific principles, in their future practices which involve handling existing and emergent health issues and problems affecting humankind. By using a combination of traditional and innovative pedagogical approaches, teachers of the School actively engage health science students in the learning of basic, applied and clinical anatomy, biochemistry and physiology.

                    </div>

                </div>
                <div style={{ display: 'flex' }}>
                    <img src={'https://static.igem.wiki/teams/4241/wiki/sponsors/new1.png'} alt='' style={{ width: '40%' }} />
                    <div>
                        <br />
                        <h2>HKU Innovation Academy</h2>
                        <br />
                        The Innovation Academy is a hub for attracting and cultivating new generations of talents, not only scholars and researchers but also industry leaders and influencers. It works as an accelerator for inspiration and implementation. In an increasingly complicated world, there is a high demand for well-rounded talents with holistic education who can comprehend and solve complex problems that transcend disciplines. InnoHub is dedicated to providing a platform to connect students from the ten faculties at The University of Hong Kong for cross-disciplinary collaboration and to prepare them for addressing the grand challenges of the world. Innowing is currently the basecamp for HKU iGEM.
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <img src={'https://static.igem.wiki/teams/4241/wiki/sponsors/new3.png'} alt='' style={{ width: '40%' }} />
                    <div>
                        <br />
                        <h2>iGEM</h2>
                        <br />
                        The International Genetically Engineered Machine competition is a worldwide synthetic biology competition that was initially aimed at undergraduate university students, but has since expanded to include divisions for high school students, entrepreneurs, and community laboratories, as well as 'overgraduates'.
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <img src={'https://static.igem.wiki/teams/4241/wiki/sponsors/new2.png'} alt='' style={{ width: '40%' }} />
                    <div>
                        <br />
                        <h2>Snapgene</h2>
                        <br />
                        SnapGene was founded by scientists and software designers to meet the everyday needs of molecular biologists. SnapGene desktop software is used in every major research institution, and in most of the largest pharmaceutical and biotech companies worldwide. The software provides a simple yet powerful way for researchers to plan, visualize, document, and share their everyday molecular biology procedures.
                    </div>
                </div>                
                <div style={{ display: 'flex' }}>
                    <img src={'https://static.igem.wiki/teams/4241/wiki/sponsors/new6.png'} alt='' style={{ width: '40%' }} />
                    <div>
                        <br />
                        <h2>Integrated DNA Technologies, Inc.</h2>
                        <br />
                        Integrated DNA Technologies, Inc., headquartered in Coralville, Iowa. For the past 30 years, IDT has developed and manufactured nucleic acid products that support the life sciences industry. The company serves many areas of biology such as academic research, biotechnology, clinical diagnostics, and pharmaceutical development. 
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
            {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
                <h1 className='des'>Sponsor</h1>
                <div className='pageholder'>

                    {/* {this.leftmenu()} */}
                    {this.righttext()}
                </div>
            </>
        )
    }
}


export default Sponsor;